import { useMutation } from "@tanstack/react-query";
import type { SuggestionDraft } from "@speakai/common/src/feedback/types";
import { sendSuggestion } from "@/features/improvements/api";

export function useSendSuggestion() {
  return useMutation({ mutationFn: (draft: SuggestionDraft) => sendSuggestion(draft) });
}
